<template>
  <div>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb v-show="routemeta.navbar" />
    <div class="container-xl">
      <div class="border-0 text-container-wider">
        <h1 class="text-primary">
          Hi {{ this.$store.state.user.first_name }} {{ this.$store.state.user.family_name }}!
        </h1>
        <div class="row mx-0 px-0">
          <div class="mx-0 px-0 col-12 col-lg-8">
            Welcome to the GDQ Learning Hub.
            <p class="mx-0 px-0 mt-4">
              Here you will find the courses you are enrolled in, follow your
              progress and access your material along the way.
            </p>
          </div>
        </div>
        <h3
          class="pt-4 mt-4"
          style="border-top: 1px solid black"
        >
          Enrolments
        </h3>
        <BaseTable
          class="mx-0 px-0 mb-4"
          :items="enrolments"
          :busy="loading"
          :fields="enrolmentsColumns"
          :per-page="enrolmentsPerPage"
        >
          <template v-slot:cell(track)="data">
            {{ trackLabel(data.item.track) }}
          </template>
          <template v-slot:cell(progress)="data">
            {{ data.item.steps_done }} / {{ data.item.steps_total }}
          </template>
          <template v-slot:cell(actions)="data">
            <div class="w-100">
              <BaseDropdown right class="w-100">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <router-link
                  class="dropdown-item"
                  :to="`/learninghub/${data.item.slug}`"
                >
                  Continue
                </router-link>
              </BaseDropdown>
            </div>
          </template>
        </BaseTable>
        <p v-if="!loading && enrolments.length === 0" class="text-muted">
          No active enrolments yet.
        </p>
      </div>
    </div>
  </div>
</template>
<script>

import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import BaseTable from './base/BaseTable.vue'
import BaseDropdown from './base/BaseDropdown.vue'

export default {
  name: 'LearningHub',
  components: {
    Navbar,
    Breadcrumb,
    BaseTable,
    BaseDropdown
  },
  data () {
    return {
      routemeta: this.$route.meta,
      enrolmentsColumns: [
        { key: 'id', sortable: true, label: 'ID', tdClass: 'd-none', thClass: 'd-none' },
        { key: 'course_name', sortable: true, label: 'Name' },
        { key: 'track', sortable: true, label: 'Track' },
        { key: 'progress', sortable: true, label: 'Progress' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      enrolmentsPerPage: 5,
      loading: true
    }
  },
  computed: {
    enrolments () {
      return this.$store.state.learninghub.my.map((e) => ({
        ...e,
        status: 'Enrolled'
      }))
    }
  },
  async created () {
    this.enrolments_get()
  },
  methods: {
    trackLabel (track) {
      return track.charAt(0).toUpperCase() + track.slice(1)
    },
    async enrolments_get () {
      this.loading = true
      await this.$store.dispatch('learninghub_my_fetch').catch(() => {})
      this.loading = false
    }
  }
}
</script>
<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: var(--line-clamp, 5);
  -webkit-box-orient: vertical;
  word-break: var(--word-break, 'none');
  overflow: hidden;
  hyphens: auto;
  text-align: var(--align, left);
  --is-single-line: 1 - Clamp(0, Calc(var(--line-clamp) - 1), var(--line-clamp));
  --delay: Calc(-1s * (var(--is-single-line, 1) - 1));
  animation: states 1s var(--delay) paused;

  @keyframes states {
      0% { word-break: break-all; }
  }
}
.text-container-wider {
  min-width: 1246px !important;
  margin: 0 auto;
}
</style>
